const CORE_HEADER = Object.freeze({
    NETTELLER_REQUIRED : 'Password',
    CORE_LOGIN_REQUIRED : 'Core-Authorization',
    NCR_REQUIRED : 'NCRRegistration',
});

export default CORE_HEADER;